const ArticleBlockTextSetup = () => {
};
ArticleBlockTextSetup();